import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { Router, RouterModule } from "@angular/router";
import { I18nService } from "../../i18n/service/i18n.service";
import { ExternalLinkManageService } from "../../service/external-link-manage/external-link-manage.service";
import { UrlUtilService } from "../../service/url-util/url-util.service";
import { IconModel } from "../icon/model/icon.model";
import { MobileComponent } from "../mobile/interface/mobile.component";
import { ChipColumn } from "./model/chipColumn";
import { Column, COLUMN_TYPE } from "./model/column";
import { IdCheckbox, Table } from "./model/table";
import { ProfileManagementService } from "../../service/store-management/profile-management/profile-management.service";
import { CommonModule } from "@angular/common";
import { ArrayColumnComponent } from "./components/array-column/array-column.component";
import { MaterialModule } from "../../module/material.module";
import { NgxPaginationModule } from "ngx-pagination";
import { CdkTableModule } from "@angular/cdk/table";
import { I18nPipe } from "../../i18n/pipe/i18n.pipe";
import { IconComponent } from "../icon/icon.component";
import { VehicleColumnComponent } from "./components/vehicle-column/vehicle-column.component";
import { IconChipsTextComponent } from "./components/icon-chips-text/icon-chips-text.component";
import { TextSubtextColumnComponent } from "./components/text-subtext-column/text-subtext-column.component";
import { VehicleDetailColumnComponent } from "./components/vehicle-detail-column/vehicle-detail-column.component";
import { ProgressBarComponent } from "../progress-bar/progress-bar.component";
import { TiresColumnComponent } from "./components/tires-column/tires-column.component";
import { ActionColumnComponent } from "./components/action-column/action-column.component";
import { FormsModule } from "@angular/forms";

// contatore usato per dare a ogni tabella un id di paginazione univoco
let paginationInstanceCounter = 0;
@Component({
  selector: "rfc-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    CdkTableModule,  
    MatSortModule,     
    NgxPaginationModule,
    I18nPipe,           
    ArrayColumnComponent,
    IconComponent,
    VehicleColumnComponent,
    IconChipsTextComponent,
    TextSubtextColumnComponent,
    VehicleDetailColumnComponent,
    ProgressBarComponent,
    TiresColumnComponent,
    FormsModule,
    RouterModule,
    ActionColumnComponent
  ]
})
export class TableComponent extends MobileComponent implements OnChanges {
  @Input() table: Table;
  @Input() exportExcel: boolean = false;
  @Input() exportPdf: boolean = false;
  @Input() exportFilter: boolean = true;
  @Input() multiplePdfDownload: boolean = false;
  @Input() massiveOperationObj;
  @Input() massiveOperationText: string;
  @Input() massiveOperationColor: string;
  @Input() secondMassiveOperationObj;
  @Input() secondMassiveOperationText: string;
  @Input() secondMassiveOperationColor: string;
  @Input() massiveOperationObjDelegation;
  @Input() massiveOperationTextDelegation: string;
  @Input() massiveOperationColorDelegation: string;
  @Input() title: string;
  @Input() loading: boolean;
  @Input() page: number;
  @Input() showZipDownloadButton: boolean = false;
  @Input() navigationState: boolean;

  @Output() onClickEvent = new EventEmitter();
  @Output() onPageChangeEvent = new EventEmitter();
  @Output() onSortSelected = new EventEmitter();
  @Output() massiveOpClick = new EventEmitter();
  @Output() secondMassiveOpClick = new EventEmitter();
  @Output() excelExport = new EventEmitter();
  @Output() pdfExport = new EventEmitter();
  @Output() zipExport = new EventEmitter();
  @Output() onRadioSelect = new EventEmitter();
  @Output() onCheckboxSelect = new EventEmitter();
  @Output() navigateWithState = new EventEmitter();

  displayedColumns: string[];
  data = [];
  rows: Array<Column>;

  count;
  tableSize = 10;

  // Senza id espliciti tutte le tabelle scriverebbero sulla stessa istanza ngx-pagination
  // (DEFAULT_PAGINATION_ID): due tabelle vive insieme si sovrascriverebbero a vicenda a
  // ogni ciclo di change detection, mandando la paginazione in loop.
  readonly paginationId = `rfc-table-${paginationInstanceCounter++}`;


  checkboxes: IdCheckbox[] = [];

  @ViewChild(MatSort) sort: MatSort;

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isCheckboxSelected = false;
  profile = this.profileManagementService.getProfileByStore()

  constructor(
    private route: Router,
    private urlUtilService: UrlUtilService,
    private manageLink: ExternalLinkManageService,
    private i18nService: I18nService,
    private profileManagementService: ProfileManagementService
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.notUndefinedCondition()) {
      this.displayedColumns = this.table.columns
        .sort((row1, row2) => row1.order - row2.order)
        .map((el) => el.id);
      this.rows = this.table.columns;
      if (!!this.table.data?.values) {
        this.data = this.table.data.values;
        this.count = this.table.data.totElements;
        this.loadCheckBoxes();
      }
    }
  }

  notUndefinedCondition(): boolean {
    return !!this.table && !!this.table.columns;
  }

  loadCheckBoxes(): void {
    const haveCheckBox = this.table.columns.some(
      (column) => column.type === COLUMN_TYPE.CHECKBOX
    );
    if (haveCheckBox) {
      this.checkboxes = this.data
        .filter((element) => element.id)
        .map((element) => ({
          id: element.id,
          checked: false,
        }));
    }
  }

  sortData(sort: Sort): void {
    this.onSortSelected.emit(sort);
  }

  pageChange(event): void {
    this.onPageChangeEvent.emit(event);
    this.page = event;
  }

  setClassToHeader(row): any {
    switch (row.type) {
      case "chip": {
        return "chip-title";
        break;
      }
      default:
        return "";
    }
  }

  setClassToHidden(): any {
    switch (this.loading) {
      case true: {
        return "hidden";
        break;
      }
      default:
        return "";
    }
  }

  getButtonLabel(row, el): any {
    const rowEl = el[row.id];
    return rowEl ? rowEl.label + "_button" : row.label;
  }

  getButtonLabelDetail(rows) {
    console.log('buttonLabel', rows?.buttonLabel)
    return this.i18nService.getTranslation(rows?.buttonLabel);
  }

  getPageInfo(p): string {
    if (this.data?.length > 0) {
      const startNumber = 1 + (p.getCurrent() - 1) * this.tableSize;
      const lastNumber = startNumber + (this.data.length - 1);
      const realCount =
        this.count < this.data.length ? this.data.length : this.count;
      return `${isNaN(startNumber) ? 0 : startNumber} - ${isNaN(lastNumber) ? 0 : lastNumber
        } su ${realCount ? realCount : 0}`;
    }
  }

  selectRow(el): void {
    if (el.on_detail) {
      this.route.navigate([el.on_detail.path]);
    } else if (el.on_click) {
      this.onClickEvent.emit(el);
    }
  }

  onclickAction(el): void {
    this.urlUtilService.setActionObjectDetail(el);
  }

  navigationTo(row, el): void {
    if (!!el[row.id]?.url) {
      this.manageLink.openLink(el[row.id].url);
    }
  }

  actionSelected(el, row, forceOnClick?: boolean): void {
    if (forceOnClick || el[row.id].on_click) {
      this.onClickEvent.emit(el);
    }
  }

  actionDetailSelected(el, row, forceOnClick?: boolean): void {
    if (forceOnClick || el[row.id].on_click) {
      this.onClickEvent.emit({ el: el, row: row });
    }
  }

  emitClicked(el, type: string): void {
    if (!!type) {
      this.onClickEvent.emit({ el, type });
    } else {
      this.onClickEvent.emit(el);
    }
  }

  iconAction(el, row, forceOnClick?: boolean): void {
    if (forceOnClick || el[row.id].on_click) {
      this.onClickEvent.emit(el[row.id]);
    }
  }

  onClickExport(filtered: boolean): void {
    this.excelExport.emit(filtered);
  }

  onClickExportPDF(filtered: boolean): void {
    this.pdfExport.emit(filtered);
  }

  onClickDownloadZip(completeZip: boolean): void {
    if (!completeZip) {
      const mergedData = this.data.map((item, i) =>
        Object.assign({}, item, this.checkboxes[i])
      );
      const selectedIds = mergedData
        .filter((element) => element.checked)
        .map((element) => element.documentId);

      if (selectedIds.length > 0) {
        this.zipExport.emit(selectedIds);
      }
    } else {
      this.zipExport.emit(false);
    }
  }

  toggleCheckboxes(checked): void {
    this.checkboxes.forEach((element) => (element.checked = checked));
    const selectedIds = this.checkboxes
      .filter((element) => element.checked)
      .map((element) => element.id);
    this.isCheckboxSelected = selectedIds.length > 0;
    this.onCheckboxSelect.emit(
      this.data.filter((element) => selectedIds.includes(element.id))
    );
  }

  toggleSelectionId(id): void {
    this.checkboxes.forEach((element) => {
      if (element.id === id) {
        element.checked = !element.checked;
      }
    });
    const selectedIds = this.checkboxes
      .filter((element) => element.checked)
      .map((element) => element.id);
    this.isCheckboxSelected = selectedIds.length > 0;
    this.onCheckboxSelect.emit(
      this.data.filter((element) => selectedIds.includes(element.id))
    );
  }

  isChecked(id): boolean {
    return this.checkboxes.find((element) => element.id === id)?.checked;
  }

  sendIdList(): void {
    const selectedIds = this.checkboxes
      .filter((element) => element.checked)
      .map((element) => element.id);
    if (selectedIds.length > 0) {
      this.massiveOpClick.emit(selectedIds);
    }
  }

  sendIdList2(): void {
    const selectedIds = this.checkboxes
      .filter((element) => element.checked)
      .map((element) => element.id);
    if (selectedIds.length > 0) {
      this.secondMassiveOpClick.emit(selectedIds);
    }
  }

  getButtonIconRow(row, el): any {
    return el[row.id].icon ? el[row.id].icon : "fa-file-excel";
  }

  getIconColor(row, el): any {
    return !!el[row.id].color ? el[row.id].color : "";
  }

  setIconAttributeForRendering(row, el): IconModel {
    if (el[row.id]) {
      return {
        isMatIcon: el[row.id].isMatIcon,
        iconClass: el[row.id].iconClass,
        iconName: el[row.id].iconName,
      } as IconModel;
    }
  }

  hideRowTitle(row): boolean {
    return row.type !== "checkbox" && row.type !== "button";
  }

  getChipStyle(el: ChipColumn): any {
    const style = {};

    if (el?.color) {
      style["backgroundColor"] = el.color;
    }

    if (el?.textColor) {
      style["color"] = el.textColor;
    }

    if (el?.isBold) {
      style["fontWeight"] = 600;
    }

    return style;
  }

  getChipClass(chip: ChipColumn) {
    const style = {};
    if (chip?.color) {
      style["backgroundColor"] = chip.color;
    }
    if (chip?.borderColor) {
      style["border"] = `1px solid ${chip.borderColor}`;
    }

    return style;
  }

  radioSelected(element): void {
    this.onRadioSelect.emit(element);
  }

  getClassStartingFromValues(row): string {
    const emptyObj = {
      iconName: "",
      label: "",
      iconClass: "",
      isMatIcon: false,
      on_click: false,
    };
    if (JSON.stringify(row) !== JSON.stringify(emptyObj)) {
      return "cursor-pointer";
    } else {
      return "";
    }
  }

  getClassTextLinkStartingFromValues(row): string {
    return "text_link";
  }

  mappingNavigateWithState(event, row) {
    this.navigateWithState.emit({ path: event, row: row });
  }
}
